// src/app/modules/Members/pages/members-table/column-formatters/RoleColumnFormatter.jsx
import React from "react";
import { Shield, Users, Lock, Briefcase, User } from "lucide-react";

const ROLE_CONFIG = {
  admin: { label: "Admin", pill: "sety-pill-red", icon: Shield },
  manager: { label: "Manager", pill: "sety-pill-purple", icon: Briefcase },
  security: { label: "Security", pill: "sety-pill-amber", icon: Lock },
  staff: { label: "Staff", pill: "sety-pill-grey", icon: Users },
  member: { label: "Member", pill: "sety-pill-green", icon: User },
};

export function RoleColumnFormatter(cellContent, row) {
  const config = ROLE_CONFIG[row.role] || ROLE_CONFIG.member;
  const Icon = config.icon;

  return (
    <span className={`sety-pill ${config.pill}`}>
      <Icon size={12} />{config.label}
    </span>
  );
}
